<script lang="ts" setup>
import { useShortCount } from "@/use/common";
import { MateWithChatInfo } from "@/types/chat";
import { useMate } from "@/stores/mate";
import { useGlobalUser } from "@/stores/globalUser";
import MateTagGroup from "@/components/mobile/chat/MateTagGroup.vue";

withDefaults(
  defineProps<{
    mate: MateWithChatInfo;
    showCount?: boolean;
    showBadge?: boolean;
  }>(),
  {
    showCount: true,
    showBadge: true,
  }
);

const mateStore = useMate();
const userStore = useGlobalUser();
</script>
<template>
  <RouterLink
    :to="{
      name: 'mateChatIntro',
      params: {
        name: mate.name,
        uuid: mate.uuid,
      },
    }"
    class="overflow-hidden rounded-lg cursor-pointer flex flex-col bg-base-200 relative border /80 hover:text-base-content"
  >
    <div class="relative rounded-lg overflow-hidden">
      <ImageCard
        :alt="mate.name"
        :media="{
          url: mate.mediaUrl,
        }"
        crossorigin="anonymous"
      />
      <div
        class="flex flex-col flex-1 gap-2 absolute top-0 bottom-0 left-0 right-0 p-2 linear-background justify-between"
      >
        <div class="flex justify-between items-center">
          <template v-if="showBadge">
            <div
              v-if="mateStore.isMyMate(mate.uuid)"
              class="badge-success badge badge-xs py-2 lg:badge-sm"
            >
              {{ $t("Message.mineCharacter") }}
            </div>
            <!--            <div-->
            <!--              v-else-if="!userStore.isHideNSFW && mate.isUnfiltered"-->
            <!--              class="badge-primary badge badge-xs py-2 text-[0.6rem] lg:badge-sm sm:text-xs"-->
            <!--            >-->
            <!--              {{ $t("Message.unfiltered") }}-->
            <!--            </div>-->
            <div v-else></div>
            <div
              v-if="false"
              class="badge bg-black/50 border-0 rounded flex items-center text-xs gap-1 p-0.5 text-white shrink"
            >
              <i class="iconify mingcute--chat-3-line text-xs" />
              {{ useShortCount(mate.chatMessageCount) }}
            </div>
          </template>
        </div>
        <div class="flex flex-col gap-1 text-white">
          <h3 class="line-clamp-1 flex font-bold w-full">
            {{ mate.name }}
          </h3>
          <div class="line-clamp-3 lg:line-clamp-4 text-xs">
            {{ mate.intro || mate.bio }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <MateTagGroup :mate="mate" class="m-2" />
    </div>
  </RouterLink>
</template>
<style scoped>
.linear-background {
  background: linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.8) 85%);
}
</style>
